import { createElementBlock as a, openBlock as t, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
};
function o(r, e) {
  return t(), a("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M9.375 3.125V1.25a.625.625 0 0 1 1.25 0v1.875a.625.625 0 1 1-1.25 0M15 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-1.25 0a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0M4.558 5.442a.625.625 0 0 0 .884-.884l-1.25-1.25a.625.625 0 0 0-.884.884zm0 9.116-1.25 1.25a.625.625 0 0 0 .884.884l1.25-1.25a.626.626 0 0 0-.884-.884M15 5.625a.63.63 0 0 0 .442-.183l1.25-1.25a.625.625 0 0 0-.884-.884l-1.25 1.25A.625.625 0 0 0 15 5.625m.442 8.933a.625.625 0 0 0-.884.884l1.25 1.25a.624.624 0 1 0 .884-.884zM3.75 10a.625.625 0 0 0-.625-.625H1.25a.625.625 0 0 0 0 1.25h1.875A.625.625 0 0 0 3.75 10M10 16.25a.625.625 0 0 0-.625.625v1.875a.625.625 0 1 0 1.25 0v-1.875A.624.624 0 0 0 10 16.25m8.75-6.875h-1.875a.625.625 0 1 0 0 1.25h1.875a.624.624 0 1 0 0-1.25"
    }, null, -1)
  ])]);
}
const h = { render: o };
export {
  h as default,
  o as render
};
